import { cx } from '@linaria/core';
import { pm2ConfigStore } from '@pm2/store';
import { units } from '@ui/css';
import { Caption } from './atoms/Caption.js';
import { wrapper, tokens, printImage } from './image.print.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

const IDEAL_PPI = 300;
const MM_PER_INCH = 25.4;
const MAX_IMG_WIDTH_IN_MM = 92;
const idealImageWidth = Math.ceil(MAX_IMG_WIDTH_IN_MM / MM_PER_INCH * IDEAL_PPI / 30) * 30;
function PrintImage(props) {
  const audience = pm2ConfigStore.useSelector(state => state.config.theme.targetAudience);
  return /*#__PURE__*/jsxs("div", {
    className: wrapper,
    style: tokens.maxWidth.__override(!props.enableScaling && props.imageWidth ? units.px(props.imageWidth) : undefined),
    children: [props.displayCaption === "above" && /*#__PURE__*/jsx(Caption, {
      position: "above",
      caption: props.caption,
      scrambled: false,
      inLightbox: false
    }), /*#__PURE__*/jsx("img", {
      alt: "",
      className: cx(printImage, audience === "Grade1To3" && "simple"),
      src: `${props.imageSrc}?w=${idealImageWidth}`
    }), props.displayCaption === "below" && /*#__PURE__*/jsx(Caption, {
      position: "below",
      caption: props.caption,
      scrambled: false,
      inLightbox: false
    })]
  });
}

export { PrintImage };
//# sourceMappingURL=image.print.js.map
